import $ from 'jquery';
import { parseUrlParam } from './../../utils';
$(function () {
  var $accordions = $('.accordion');
  var $accordionTitles = $('.accordion__title');
  var opensesame = parseUrlParam('opensesame');
  if (!$accordions || !$accordions.length) {
    return;
  }
  if (opensesame) {
    $accordions.addClass('active');
  }
  $accordionTitles.on('click touch', toggleAccordion);
  function toggleAccordion() {
    var $title = $(this);
    var $accordion = $title.closest('.accordion');
    var method = $accordion.hasClass('active') ? 'removeClass' : 'addClass';
    $accordions.removeClass('active');
    $accordion[method]('active');
  }
});